export default "__VITE_ASSET__539fe509__"